<template>
  <div class="radar-buy">
    <div class="language-switcher">
      <router-link :to="{ path: '/' }" class="lang-link" :class="{ active: $route.path === '/' }">RU</router-link>
      <span class="lang-separator">|</span>
      <router-link :to="{ path: '/en' }" class="lang-link" :class="{ active: $route.path === '/en' }">EN</router-link>
    </div>
    <div>
      <div class="title">
        <h1>ВХ для КС2 / Wallhack для CS2</h1>
      </div>
      <div class="description">
        <h2>
          Здесь вы можете бесплатно скачать вх для кс без регистрации!
          <br/><span class="demo-text"><b>1</b> день демо периода для новых пользователей</span> (демо период может быть отключен в выходные дни)
        </h2>
        <p>
          Наш чит (ВХ) содержит только самый нужный функционал и не использует оверлеев.
          <b class="demo-text">Предназначен для тренировочных игр с компьютерными противниками (ботами).</b><br />
          <br />
          Обязательно ознакомьтесь с инструкциями по установке и запуску.<br />
          После окончания демо периода, вы можете выбрать удобный для себя вариант подписки. <b>Подписка привязывается к железу ПК.</b>
        </p>
      </div>
      <div class="btn-section">
        <div>
          <Button text="СКАЧАТЬ ВХ CS2 (загрузчик)" @click="checkBeforeDownload" />
        </div>
        <router-link title="Купить подписку на вх для кс2" to="/buykey">
          <Button text="ПОДПИСКА" />
        </router-link>
      </div>
      <div class="demo-text navigation">
        <a href="#guide" title="Как запустить ВХ">Как запустить</a>
        <!-- <router-link :to="{ name: 'Guide' }" title="Как установить ВХ">Как установить</router-link> -->
        <router-link :to="{ name: 'Faq' }" title="Возможные ошибки при запуске ВХ">Ошибки при запуске</router-link>
      </div>
    </div>

    <div style="display: flex; justify-content: center;">
      <video width="100%" height="auto" controls>
        <source src="@/assets/video/demo_video.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
    <div class="section advertisers">
      <h2>НАШИ ПРЕИМУЩЕСТВА:</h2>
      <ul>
        <li>Без регистрации</li>
        <li>Не нужно устанавливать никакие программы. Достаточно скачать .exe файл в архиве</li>
        <li>Вам не нужно снова скачивать или обновлять клиент после обновлений КС</li>
        <li>Используем только самый нужный функционал, который поможет натренироваться в игре с ботами</li>
        <li>Не используем оверлеи, что положительно сказывается на производительности</li>
        <li>Своевременные обновления и поддержка актуальной версии КС</li>
        <li>Большой выбор вариантов подписки</li>
      </ul>
    </div>
    <div class="section guide">
      <h2 id="guide">КАК ЗАПУСТИТЬ ВХ:</h2>
      <video width="100%" height="auto" controls>
        <source src="@/assets/video/guide.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
      <br/><br/>
      <p><b>*Проверено на Windows 10/11</b></p>
      <p>1. Переместите скачанный файл <a @click="checkBeforeDownload" title="Скачать апдейтер cssoftshop"><b>updater</b></a> в папку,
        куда хотите установить программу и запустите его.
        Апдейтер автоматически скачает необходимые файлы.
        (<b>Антивирус может помешать скачиванию файлов или удалить некоторые, будьте внимательны!</b>)<br/><br/>
        <!-- <b>Вариант с архивом (устаревший)</b><br/>
        <router-link :to="{ name: 'Guide' }">
          Распаковать архив с программой
        </router-link>
        , запустить сначала <b>CS2</b> затем <b>ВХ</b>
        <br/><br/> -->
        2. В настройках игры (<span class="demo-text"><b>ИЗОБРАЖЕНИЕ &#129046; ГРАФИКА</b></span>)
        выставите <span class="demo-text"><b>"ПОЛНОЭКРАННЫЙ В ОКНЕ"</b></span>
        или <span class="demo-text"><b>"В ОКНЕ"</b></span>
      </p>
      <div style="margin-top: 10px; text-align: center;">
        <img class="gui_example" alt="Чит ВХ для кс 2 и его интерфейс" title="Интерфейс чита" src="../assets/img/cs2_cheat_v_2_0.png" />
      </div>
      <p>3. Создайте и запустите игру с ботами и после загрузки нажмите "Включить"</p>
      <div style="margin-top: 10px; text-align: center;">
        <img
          class="esp_example"
          alt="Пример работы ВХ кс 2 - подсветка уровня HP"
          title="Пример работы чита cs go - подсветка уровня HP"
          src="../assets/img/cs2_esp.png"
        />
      </div>
      <div style="margin-top: 10px; text-align: center;">
        <img class="esp_example" alt="Пример работы чита кс 2" title="Пример работы чита cs go" src="../assets/img/cs2_esp settings.png" />
      </div>
      <p>После этого, в любой момент можно отключать и включать ВХ (без перезапуска CS)</p>
      <p>
        <b>Важно:</b> если чит включен, но эффекта не наблюдается, возможно, произошло обновление CS.<br />
        Необходимо подождать, пока мы обновим наш сервер и запустить чит еще раз. Приятной игры :)
      </p>
      <p>
        Проверить обновления или задать вопрос в тех. поддержку можно в
        <a target="_blank" href="https://vk.com/cssoftshop" title="Группа ВК">группе ВК</a>
      </p>
    </div>
    <!-- <div class="section news">
      <h2>НОВОСТИ И ОБНОВЛЕНИЯ:</h2>
      <div id="vk_groups" />
    </div> -->
    <!-- <div class="section">
      <h2>ПАРТНЕРЫ:</h2>
      <a href="https://play.google.com/store/apps/details?id=com.krayud.only_true"
        class="truth-or-dare" target="_blank" title="Мобильная игра Правда или действие">
        <img style="width: 100%" src="@/assets/img/truth_or_dare_logo.jpg" />
      </a>
    </div> -->
    <el-dialog
      :visible.sync="centerDialogVisible"
      title="Соглашение"
      append-to-body
      :lock-scroll="false"
      :destroy-on-close="true"
      class="window-style"
      @closed="downloadWindowClosed"
      center
    >
      <p class="demo-text" style="word-break: break-word;">
        Программа предназначена <b>исключительно</b> для тренировочных игр с компьютерными противниками (ботами).
        Используя её, вы соглашаетесь с этим условием и подтверждаете, что
        прочли и принимаете <a target="_blank" style="color: white;" href="https://cssoftshop.ru/terms">Условия использования</a> <br /><br />
        При передаче программы другим лицам, вы должны ознакомить их с условиями использования.<br /><br />
        Программа может использовать сторонние библиотеки (например RestSharp)<br /><br />
        Программа устанавливается с помощью <b>загрузчика-апдейтера</b>. Он используется и для обновления программы.
      </p>
      <br />
      <el-checkbox v-model="iAgree" class="agree_checkbox">Я прочёл и согласен с условиями использования</el-checkbox><br />
      <el-checkbox v-model="iAgree2" class="agree_checkbox">Согласен на установку загрузчика и сторонних библиотек</el-checkbox>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="!iAgree || !iAgree2" type="success" :disabled="true">Перейти на сайт загрузчика</el-button>
        <a v-else href="https://cloudcss.ru" target="_blank">
          <el-button type="success" :disabled="!iAgree || !iAgree2">Перейти на сайт загрузчика</el-button>
        </a>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Button from '@/components/Button.vue';
import { isDeprecatedWindows } from '@/utils/utils';

export default {
  name: 'Home',
  components: {
    Button,
  },
  metaInfo() {
    const baseUrl = 'https://cssoftshop.ru';
    return {
      title: 'ВХ для КС2 / Wallhack для CS2',
      meta: [{ name: 'description', content: 'Чит ВХ для КС2 (CS2). Простой в использовании, невидим для VAC.' }],
      link: [
        { rel: 'canonical', href: baseUrl },
        { rel: 'alternate', hreflang: 'ru', href: baseUrl },
        { rel: 'alternate', hreflang: 'en', href: `${baseUrl}/en` },
        { rel: 'alternate', hreflang: 'x-default', href: baseUrl },
      ],
    };
  },
  data() {
    return {
      centerDialogVisible: false,
      isDownloading: false,
      iAgree: false,
      iAgree2: false,
    };
  },
  methods: {
    checkBeforeDownload() {
      if (false && isDeprecatedWindows()) {
        this.$notify.error({
          title: 'Ошибка',
          message: 'Для корректной работы программы требуется Windows 10 и выше',
        });
      } else {
        this.centerDialogVisible = true;
      }
    },
    downloadWindowClosed() {
      this.iAgree = false;
      this.iAgree2 = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
a
  cursor: pointer

.radar-buy
  text-align: left
  max-width: 900px
  .title
    text-align: center
    margin-bottom: 20px
.btn-section
  margin: 30px 0px 30px 0px
  display: flex
  justify-content: space-evenly
  flex-wrap: wrap
  gap: 10px
.demo-text
  color: #ff6130
  a
    color: #ff6130

.esp_example
  width: 450px
  max-width: 100%

.gui_example
  width: 296px

.image-caption
  font-size: 12px

.advertisers
  color: white
  li
    margin-left: 30px
    color: white
    font-size: 18px
    line-height: 1.5
    &::marker
      content: '👍 '

/deep/ .el-dialog
  background-color: #1e1e1e
  border-radius: 10px
/deep/ .el-dialog__title
  color: white

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner
    background-color: #67C23A
    border-color: #67C23A

/deep/ .el-checkbox__input.is-checked+.el-checkbox__label
  color: #67C23A

/deep/ .el-icon-close
  &:hover
    color: #ff8000

.truth-or-dare
  opacity: 0.8
  transition: opacity 0.15s ease-in-out

  &:hover
    opacity: 1

.agree_checkbox
  display: flex
  align-items: center
  /deep/ .el-checkbox__label
    white-space: normal

.navigation
  font-size: 18px
  font-weight: bold
  margin-bottom: 30px
  display: flex
  justify-content: center
  flex-wrap: wrap
  align-content: space-between
  gap: 10px

.window-style
  max-width: 100%
  /deep/ .el-dialog
    max-width: 600px
    width: 90%
    min-width: 320px

.language-switcher
  position: absolute
  top: 20px
  right: 20px
  font-size: 16px
  font-weight: bold

  .lang-link
    color: #666
    text-decoration: none
    transition: color 0.3s ease

    &:hover
      color: #ff6130

    &.active
      color: #ff6130

  .lang-separator
    margin: 0 10px
    color: #666
</style>
